import { coerce } from '../bytes.js';

var raw = function raw(bytes) {
  return coerce(bytes);
};

var _name$code$decode$enc = {
  name: 'raw',
  code: 85,
  decode: raw,
  encode: raw
},
    name = _name$code$decode$enc.name,
    code = _name$code$decode$enc.code,
    encode = _name$code$decode$enc.encode,
    decode = _name$code$decode$enc.decode;
export { name, code, encode, decode };